import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlProductsEdge } from '../../graphqlTypes'

const Container = styled.ul`
  display: flex;
  list-style: none;
  overflow-x: scroll;
  padding: 16px 0 0 16px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 35px 0 0;
    padding: 0;
  }
`

const Item = styled.li`
  background: ${({ theme }) => theme.palette.background.main};
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 5px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  margin: 0 12px 0 0;
  padding: 8px;
  position: relative;
  width: 116px;
  &:last-child {
    margin: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 16px;
      height: 100%;
    }
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border: 0;
    box-shadow: none;
    margin: 0 7px 0 0;
    padding: 7px;
    width: 165px;
  }
`

const ProductLink = styled(Link)`
  display: block;
  text-decoration: none;
`

const Image = styled.img`
  display: block;
  object-fit: contain;
  width: 100px;
  height: 100px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 165px;
    height: 165px;
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 10px;
  font-weight: bold;
  margin: 8px 0 0;
`

const Manufacturer = styled.p`
  margin: 0 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Name = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 12px;
  }
`

export default function ProductList({ products }: { products: MysqlProductsEdge[] }) {
  return (
    <Container>
      {products.map(({ node }) => (
        <Item key={node.id}>
          <ProductLink to={node.fields!.pagePath!}>
            <LazyLoadComponent>
              <Image alt={node.name!} src={`${node.fields!.withEmblemImageUrl}?auto=format&max-w=165px&max-h=165`} />
            </LazyLoadComponent>
            <Text>
              {node.manufacturer && <Manufacturer>{node.manufacturer}</Manufacturer>}
              <Name>{node.name}</Name>
            </Text>
          </ProductLink>
        </Item>
      ))}
    </Container>
  )
}
